<p-drawer
  position="right"
  [visible]="visible"
  [style]="{ width: '40rem', maxWidth: '100vw' }"
  [showCloseIcon]="false"
  (visibleChange)="visibleChange.emit($event)"
>
  <ng-template pTemplate="header">
    <div class="history-drawer-header">
      <div class="text-lg font-semibold text-gray-800">
        {{ 'package_operation.history.title' | translate }}
      </div>
      <button
        type="button"
        class="history-drawer-close"
        [attr.aria-label]="'common.actions.close_dialog' | translate"
        (click)="close()"
      >
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </div>
  </ng-template>

  @if (packageSku; as selectedPackage) {
    <dl class="package-summary">
      <div>
        <dt>{{ 'package_operation.history.package_sku' | translate }}</dt>
        <dd>{{ selectedPackage.skuName || '-' }} - {{ selectedPackage.skuCode || '-' }}</dd>
      </div>
      <div>
        <dt>{{ 'package_operation.history.spu' | translate }}</dt>
        <dd>{{ selectedPackage.spuName || '-' }} - {{ selectedPackage.spuCode || '-' }}</dd>
      </div>
    </dl>

    @if (loading) {
      <p class="text-sm text-gray-500">{{ 'common.messages.loading' | translate }}</p>
    } @else if (historyItems.length > 0) {
      <div class="operation-timeline">
        @for (operation of historyItems; track operation.id ?? operation.operationNo) {
          <article
            class="timeline-entry"
            [class.timeline-entry-pack]="operation.operationType === 'PACK'"
            [class.timeline-entry-unpack]="operation.operationType === 'UNPACK'"
          >
            <span class="timeline-marker" aria-hidden="true"></span>
            <div class="timeline-card">
              <div class="timeline-event">
                <span class="timeline-event-indicator" aria-hidden="true"></span>
                <span class="timeline-event-label">
                  {{ operationTypeLabel(operation.operationType) | translate }}
                </span>
              </div>
              <div class="timeline-meta">
                <span>{{ operation.creationDate | date: 'dd/MM/yyyy HH:mm' }}</span>
                <span aria-hidden="true">•</span>
                <span>{{ operation.createdBy || '-' }}</span>
              </div>
              <dl class="timeline-details">
                <div>
                  <dt>{{ 'package_operation.history.quantity' | translate }}</dt>
                  <dd>{{ (operation.packageQty ?? 0) | number }}</dd>
                </div>
                <div>
                  <dt>{{ 'package_operation.history.warehouse' | translate }}</dt>
                  <dd>{{ warehouseLabel(operation) }}</dd>
                </div>
                <div class="timeline-detail-reason">
                  <dt>{{ 'package_operation.history.reason' | translate }}</dt>
                  <dd>{{ operation.reason || '-' }}</dd>
                </div>
              </dl>
            </div>
          </article>
        }
      </div>
    } @else {
      <div class="text-sm text-gray-500">
        {{ 'package_operation.history.empty' | translate }}
      </div>
    }
  }
</p-drawer>
